module.exports = __webpack_public_path__ + "static/media/exit.15547278.svg";